import { translate } from "app/filters/i18nFilter";
import { abbrNumberWithPrefixFilter } from "app/filters/ngFilters";
import { DOLLAR_PREFIX } from "app/pages/sales-intelligence/modules/find-apps-filters/constants";
import { getRangeChipValue } from "app/pages/sales-intelligence/modules/find-apps-filters/utils";
import type { IAppsPriceFilterDto } from "app/pages/sales-intelligence/store/find-apps/types";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

const formatNumber = abbrNumberWithPrefixFilter();

function formatChipsContent(value: IAppsPriceFilterDto): string {
    const typeLabel = translate(`si.find_apps.filters.price.${value.type}.label`);

    const { from, to } = value?.priceRange || {};

    if (is.undefined(from) && is.undefined(to)) {
        return typeLabel;
    }

    const formattedFrom: string = is.undefined(from) ? "" : (formatNumber(from, DOLLAR_PREFIX) as string);
    const formattedTo: string = is.undefined(to) ? "" : (formatNumber(to, DOLLAR_PREFIX) as string);

    return `${typeLabel}: ${getRangeChipValue({ from: formattedFrom, to: formattedTo }, false)}`;
}

export default formatChipsContent;
